import script from "./Tdashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./Tdashboard.vue?vue&type=script&setup=true&lang=js"

import "./Tdashboard.vue?vue&type=style&index=0&id=3df9546c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3df9546c"]])

export default __exports__